import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';

export type OperatingArea =
  | "Público"
  | "Industrial y Comercial"
  | "Salud"
  | "Vivienda";

export interface Project {
  id: number;
  title: string;
  businessArea: OperatingArea | string;
  description: string;
  imageUrl: string | null;
  imagesGallery: string[];
  location: string;
  client: string;
  clientLogoUrl: string | null;
  dateCompleted: string | null;
  areaSqM: number | null;
}

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  private projectsUrl = 'assets/data/projects.json';
  private projects$: Observable<Project[]>;

  constructor(private http: HttpClient) {
    this.projects$ = this.http.get<Project[]>(this.projectsUrl).pipe(
      shareReplay(1)
    );
  }

  getProjects(): Observable<Project[]> {
    return this.projects$;
  }
}
